class Zv {
	static delegate(selector, listener){
		return (e)=> {
			e.delegateTarget = e.target.closest(selector);
			if(e.delegateTarget) {
				listener.apply(this, [e]);
			}
		}
	}
	static serialize(data) {
		return Object.keys(data).map(function (keyName) {
			return encodeURIComponent(keyName) + '=' + encodeURIComponent(data[keyName])
		}).join('&');
	}
	static async ajax(url, data = {}){
		data.credentials = 'same-origin';
		data.headers = data.headers || new Headers();
		data.headers.append('X-Requested-With', 'XMLHttpRequest');
		if(data.body && R.is(FormData, data.body)){
			data.body.set('bx_valid_json', 'Y'); //Специальная переменная, которая подключит кастомную ф-ию bx_js_encode в init.php
		}
		return await fetch(url, data);
	}
	static async post(url, params){
		const data = {
			method: 'POST',
			headers: {'Content-Type': 'application/x-www-form-urlencoded'},
			body: Zv.params(params)
		};
		return await this.ajax(url, data);
	}
	// {foo: {bar: { baz: 123, agr: 'ogr' }}, demo: 'aaa'} -> foo[bar][baz]=123&foo[bar][agr]=ogr&demo=aaa
	static params(obj = {}){
		const _params = (_obj, name = '') => R.chain(
			([k, v]) => {
				let _name;
				k = encodeURIComponent(k);
				_name = name + (name.length?`[${k}]`:k);
				if (R.is(Object, v)){
					return _params(v, _name);
				} else {
					return [[_name, encodeURIComponent(v)]]
				}
			},
			Object.entries(_obj)
		);
		return _params(obj).map(R.join('=')).join('&');
	}
	static insertScript($script){
		const scriptNode = document.createElement('script');
		if($script.scr){
			return;
		}else{
			scriptNode.textContent = $script.textContent;
			$script.replaceWith(scriptNode);
		}
	}
	static get Rx() {
		return {
			delegate(selector){
				return (e) => Object.assign(e, {delegateTarget: e.target.closest(selector)});
			}
		}
	}
	static get Math() {
		return {
			round(v, n = 0){
				return Math.round(v  * 10 ** n) / 10 ** n;
			},
			ceil(v, n = 0){
				return Math.floor(v  * 10 ** n) / 10 ** n;
			},
			floor(v, n = 0){
				return Math.floor(v  * 10 ** n) / 10 ** n;
			}
		};
	}
}